import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import SavedPaymentMethods from '../components/SavedPaymentMethods';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';

const PaymentSettings = () => {
  const navigate = useNavigate();

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="icon" onClick={() => navigate(-1)}>
          <ArrowLeft className="w-5 h-5" />
        </Button>
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Payment Methods</h1>
          <p className="text-gray-600">Manage your saved payment methods for quick checkout</p>
        </div>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Saved Cards</CardTitle>
        </CardHeader>
        <CardContent>
          <SavedPaymentMethods showAddNew={true} />
        </CardContent>
      </Card>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <h3 className="font-semibold text-blue-900 mb-2">💳 Quick Checkout</h3>
        <p className="text-sm text-blue-800">
          Save your payment methods for faster booking. Your card information is securely stored by Stripe and never saved on our servers.
        </p>
      </div>
    </div>
  );
};

export default PaymentSettings;
